import React, { useEffect, useState } from 'react'
import * as _ from 'lodash'
import './SummaryProductBudget.scss'
import { connect } from 'react-redux'
import { updateProductBudget, popProductBudget } from '../actions/index'
import { SummaryProductBudgetDesktop } from './SummaryProductBudgetDesktop'
import { SummaryProductBudgetMobile } from './SummaryProductBudgetMobile'


const SummaryProductBudget = (props) => {
    const { productBudget, allProducts, changeProduct } = props
    const [numberInit, setNumberInit] = useState(1)
    const [total, setTotal] = useState(null)

    useEffect(() => {
        handleCalcTotal()
        if (productBudget.product.Diametro.toLowerCase().indexOf('set/') > -1) {
            handleGetDiameterMaxMinSet(productBudget.product.ProductosSet)
        }
        if (productBudget.product.Descripcion.toLowerCase().indexOf('mix ') > -1) {
            handleGetDiameterMaxMinSet(productBudget.product.ProductosExpositor)
        }
    }, [props])

    const handleGetDiameterMaxMinSet = (productosId) => {
        const productosSet = productosId.split(', ').filter(item => item)
        const productsAllSet = []
        for (let i = 0; i < productosSet.length; i++) {
            const productoSet = productosSet[i];
            if (productoSet.indexOf('$') === -1) {
                productsAllSet.push(_.filter(allProducts, { 'RefSuelto': productoSet })[0])
            }
        }
    }

    const handleCalcTotal = () => {
        setNumberInit(productBudget.quantity)
        let totalQuantity = 0;
        if (productBudget.format === 'UVenta2021Suelto' || productBudget.format === 'expositor') {
            totalQuantity = productBudget.quantity;
        } else if (productBudget.format === 'UnidadesPack') {
            totalQuantity = productBudget.quantity * productBudget.product.UnidadesPack;
        } else {
            totalQuantity = productBudget.quantity * productBudget.product.UnidadesPallet;
        }
        productBudget.total = totalQuantity;
        setTotal(totalQuantity)
        changeProduct()
    }

    const handleClickChange = (value) => {
        if (productBudget.format === 'UVenta2021Suelto' && value >= productBudget.product.UVenta2021) {
            productBudget.quantity = value;
            props.updateProductBudget(productBudget)
        } else if (value >= 1) {
            productBudget.quantity = value;
            props.updateProductBudget(productBudget)
        }
        handleCalcTotal()
    }

    const handleClickDelete = (product) => {
        props.popProductBudget(product)
    }

    return (
        <div className="summary-product-budget-container">
            <div className="summary-mobile">
                <SummaryProductBudgetMobile
                    productBudget={productBudget}
                    numberInit={numberInit}
                    total={total}
                    clickChange={handleClickChange}
                    clickDelete={handleClickDelete}
                />
            </div>
            <div className="summary-desktop">
                <SummaryProductBudgetDesktop
                    productBudget={productBudget}
                    numberInit={numberInit}
                    total={total}
                    clickChange={handleClickChange}
                    clickDelete={handleClickDelete}
                />
            </div>
        </div>
    )
}

const mapDispatchToProps = {
    updateProductBudget,
    popProductBudget
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(SummaryProductBudget)
